import { Divider } from "@mui/material";
import * as React from "react";
import { useContext } from "react";
import { GroupChatListPanelHeader } from "../GroupChatListPanelHeader";
import HiddenGroupChatList from "./HiddenGroupChatList";
import { FilteredHiddenChatsContext } from "hhn-commons";
import { GroupChatListPanelHeaderWrapper } from "../group/patient/PatientChats.styles";

type HiddenGroupChatListSearchViewProps = {
  selectedChatId?: string;
};

export const HiddenGroupChatListSearchView = ({
  selectedChatId,
}: HiddenGroupChatListSearchViewProps) => {
  const { chatData, isChatLoading, fetchChats } = useContext(
    FilteredHiddenChatsContext,
  );

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={chatData?.unreadChatCount || 0}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <HiddenGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
